<template>
  <div class="centerIntro-wrap">
    <div class="centerIntro-content">
      <Breadcrumb :options="crumbOptions"></Breadcrumb>
      <div class="title">{{ detailContent.title }}</div>
      <div class="summary">
        <span>{{ tag }}</span
        ><span>{{detailContent.author}}</span><span>{{detailContent.publishTime}}</span>
      </div>
      <div class="content">
        <div v-html="detailContent.content"></div>
        <div class="downClass"  v-if="detailContent.appendixFiles">
          <div>附件：</div>
          <div v-for="item in detailContent.appendixFiles" :key="item.fileId" class="downDiv">
            <div >
              <span class="name">{{item.fileName}}</span>
              <a-icon class="icon" type="download" @click="downClick(item)" />
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import { getCurrentCrumb } from '@/utils/crumb.js'
import { downFile } from '@/api/home'
export default {
  data () {
    return {
      crumbOptions: [],
      detailContent: ''
    }
  },
  components: {
    Breadcrumb
  },
  created () {
    this.settingCrumb()
    const { id, tag } = this.$route.query
    this.tag = tag
    this.$store.dispatch('articleDetail/getDetail', { id }).then(ele => {

      this.detailContent = ele.data
    })
  },
  methods: {
    settingCrumb () {
      const { path } = this.$route
      const crumbOptions = getCurrentCrumb(path)
      console.log(crumbOptions);
      this.crumbOptions = crumbOptions
    },
    async downClick(item) {
      
      const data = await downFile(item.fileId)
      
      const blob = new Blob([data])
      const elink = document.createElement('a')
      elink.download = item.fileName
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    },
     // 下载文件
     downloadFile (name, url) {
      const a = document.createElement('a');
      a.setAttribute('download', name);
      a.setAttribute('href', url);
      a.click();
      document.body.removeChild(a)
    },
  }

}
</script>
